import React, { useEffect, useState } from 'react'
import useAuthInfo from '../../../../hooks/IsAdmin';
import { S_FORMAT_INR_CURRENCY_AND_AMOUNT, SD_GET_YEAR_DATA } from '../../../includes/staticData';
import axios from 'axios';
import * as CONST from '../../../includes/Constant';
import BlockLoading from '../../../blocks/BlockLoading';
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
export default function DepartmentReceivedVsRaised({ searchParams }) {
  console.log(searchParams);
  console.log(searchParams.year);
  const [deaprtmentsData, setDeaprtmentsData] = useState(null);
  const [financialYears, setFinancialYears] = useState(null);
  const { isAdmin, eDepartmentId } = useAuthInfo();
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);
  const { YEAR_LIST, CURRENT_FINANCIAL_YEAR, SELECTED_YEAR } = SD_GET_YEAR_DATA();
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [searchParams]);
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(CONST.DASH_DPT_RAISED_VS_RECEIVED, {
        params: {
          year: searchParams.year,
          month: searchParams.month
        }
      });
      setDeaprtmentsData(response.data.data || []);
    } catch (error) {
      toast.error('Error fetching financial summary:', error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>

      {loading ? (
        <BlockLoading />
      ) : (
        <>
          {
            deaprtmentsData && deaprtmentsData.map((item, index) => {
              const raised_img_path = "/assets/img/1.svg";
              const received_img_path = "/assets/img/2.svg";
              return (
                <>
                  <Col xs={12} sm={6} md={4} key={index}>
                    <div className={`card flex-fill card-opacity rounded-32 dashboard-card bg-success-light`}>
                      <div className="card-body">

                        <div className="row mb-1 align-items-center">
                          <div className="col mt-0">
                            <h5 className="card-title">{item.name} <small>Cashflow</small></h5>
                          </div>

                        </div>
                        <div className="box-wrapper">
                          <div className="internal-wrapper" >
                            <div className="icon-wrapper">
                              <img
                                src={
                                  process.env.PUBLIC_URL + raised_img_path
                                }
                                alt="eLuminous Logo"
                                className="logo"
                              />
                            </div>
                            <div className="title-wrapper">
                              <h6>Raised</h6>
                              <h2>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(item.total_raised || 0)}</h2>
                            </div>
                          </div>
                          <div className="internal-wrapper" >
                            <div className="icon-wrapper">
                              <img
                                src={
                                  process.env.PUBLIC_URL + received_img_path
                                }
                                alt="eLuminous Logo"
                                className="logo"
                              />
                            </div>
                            <div className="title-wrapper">
                              <h6>Received</h6>
                              <h2>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(item.total_received || 0)}</h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </>
              )
            }
            )
          }
        </>
      )
      }

    </>
  )
}
